import { axiosInstance } from "@/plugins/axios";
import logger from "@/plugins/logger";
import dayjs from "dayjs";
import { Firearm, Certification } from "models";
import { Certification as DocCert } from "@/models/documents";

const Firearms = () => {
  const baseUrl = "/api/firearmsAPI";
  const validateFirearm = async (
    firearmId: number,
    aroId: number
  ): Promise<{
    status: number;
    message: string;
    sapsCompetencyCertificate?: DocCert;
  }> => {
    const res = await axiosInstance.get<{
      status: number;
      message: string;
      sapsCompetencyCertificate?: Certification;
    }>(baseUrl + "/ValidateFirearm?firearmID=" + firearmId + "&aroID=" + aroId);
    return Promise.resolve({
      ...res.data,
      sapsCompetencyCertificate: new DocCert(
        res.data.sapsCompetencyCertificate
      ),
    });
  };

  const getFirearmByIDAsync = async (id: number): Promise<Firearm> => {
    const res = await axiosInstance.get(
      baseUrl + "/getFirearmByIDAsync?firearmID=" + id
    );
    return Promise.resolve(res.data);
  };

  const getFirearmByIDAsyncForIncident = async (id: number): Promise<any> => {
    const res = await axiosInstance.get(
      baseUrl + "/getFirearmByIDForIncident?firearmID=" + id
    );
    return Promise.resolve(res.data);
  };

  const getAllFirearms = async (addImages: boolean): Promise<Firearm[]> => {
    const res = await axiosInstance.get(
      baseUrl + `/getFirearm?addImages=${addImages}`
    );
    return Promise.resolve(res.data);
  };

  const addFirearm = async (data: FormData): Promise<void> => {
    const res = await axiosInstance.post(baseUrl + "/addFirearm", data);
    return Promise.resolve(res.data);
  };

  const editFirearm = async (data: FormData): Promise<void> => {
    const res = await axiosInstance.post(baseUrl + "/editFirearm", data);
    return Promise.resolve(res.data);
  };

  const deleteFirearm = async (
    id: number,
    reason: string,
    otherReason: string
  ): Promise<void> => {
    const res = await axiosInstance.post(
      baseUrl +
        `/softDeleteFirearm?firearmID=${id}&radioDeleteReason=${reason}&otherReason=${otherReason}`
    );
    return Promise.resolve(res.data);
  };

  const archiveFirearm = async (payload: any): Promise<void> => {
    const res = await axiosInstance.put(baseUrl + `/archiveFirearm`, payload);
    return Promise.resolve(res.data);
  };

  const restoreFirearm = async (id: number): Promise<void> => {
    const res = await axiosInstance.put(
      baseUrl + `/restoreFirearm?firearmID=${id}`
    );
    return Promise.resolve(res.data);
  };

  const DownLoadFirearmFile = async (id: number): Promise<Firearm[]> => {
    const res = await axiosInstance.get(baseUrl + `/downLoadFile?id=${id}`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "image/jpeg" + "application/pdf" + "image/png",
      },
      responseType: "blob",
    });
    return Promise.resolve(res.data);
  };

  const DownLoadFirearmImage = async (id: number): Promise<Firearm[]> => {
    const res = await axiosInstance.get(
      baseUrl + `/downLoadFirearmImage?id=${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "image/jpeg" + "application/pdf" + "image/png",
        },
        responseType: "blob",
      }
    );
    return Promise.resolve(res.data);
  };

  const DownLoadFirearmRenewedFile = async (id: number): Promise<Firearm[]> => {
    const res = await axiosInstance.get(
      baseUrl + `/downLoadFirearmRenewedFile?id=${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "image/jpeg" + "application/pdf" + "image/png",
        },
        responseType: "blob",
      }
    );
    return Promise.resolve(res.data);
  };

  const importFirearm = async (data: FormData): Promise<void> => {
    const res = await axiosInstance.put(baseUrl + `/importFirearms`, data);
    return Promise.resolve(res.data);
  };
  const checkFirearmAvailability = async (
    firearmID: number,
    securityFirmID: number,
    initDate: string,
    initTime: string,
    termDate: string,
    termTime: string,
    aroID: number
  ): Promise<{
    status: "Error" | "Success";
    message: string;
  }> => {
    try {
      const res = await axiosInstance.get<{
        status: "Error" | "Success";
        message: string;
      }>(
        `/api/permitsAPI/checkFirearmAssignment?firearmID=${firearmID}&securityFirmID=${securityFirmID}&startDate=${initDate} ${initTime}&endDate=${termDate} ${termTime}&armResponseOfficerId=${aroID}`
      );
      logger.log(
        "Firearm availability",
        `/api/permitsAPI/checkFirearmAssignment?firearmID=${firearmID}&securityFirmID=${securityFirmID}&startDate=${initDate} ${initTime}&endDate=${termDate} ${termTime}`,
        res.data
      );
      return Promise.resolve(res.data);
    } catch (err) {
      logger.error(err);
      return Promise.reject(false);
    }
  };

  return {
    getFirearmByIDAsync,
    getAllFirearms,
    addFirearm,
    editFirearm,
    deleteFirearm,
    archiveFirearm,
    validateFirearm,
    restoreFirearm,
    getFirearmByIDAsyncForIncident,
    checkFirearmAvailability,
    DownLoadFirearmFile,
    DownLoadFirearmImage,
    DownLoadFirearmRenewedFile,
    importFirearm,
  };
};
const temp = Firearms();
export default temp;
